import { Action, createReducer, on } from '@ngrx/store';
import { RequestState } from '../../../shared/definitions/request-state.enum';
import * as TaxonomyStoreActions from './taxonomy-store.actions';
import { State, initialState } from './taxonomy-store.state';

const taxonomyReducer = createReducer(
  initialState,
  on(TaxonomyStoreActions.fetchTaxonomyTerms, state => ({
    ...state,
    taxonomyTermsRequestState: RequestState.InProgress,
  })),
  on(
    TaxonomyStoreActions.fetchTaxonomyTermsSucceeded,
    (state, { taxonomyTerms }) => ({
      ...state,
      taxonomyTermsRequestState: RequestState.Succeeded,
      taxonomyTerms: [...taxonomyTerms],
    }),
  ),
  on(TaxonomyStoreActions.fetchTaxonomyTermsFailed, state => ({
    ...state,
    taxonomyTermsRequestState: RequestState.Failed,
  })),
  on(TaxonomyStoreActions.resetTaxonomyStore, () => initialState),
);

export function reducer(state: State | undefined, action: Action) {
  return taxonomyReducer(state, action);
}
